import './../../../lang/assets/continue1/css/theme.css';
import './../../../lang/assets/continue1/css/demos/demo-creative-agency-1.css';
import './../../../lang/css/skins/default.css';
import './../../../lang/assets/continue1/css/skins/skin-creative-agency-1.css';
import './../../../lang/css/custom.css';
import './../../../lang/assets/css/custom.css';
import './../../../lang/assets/css/footer.css';
import './../../../lang/assets/js/plain.js';

console.log('Webpack and CSS are working!');

